import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, unref as _unref, createBlock as _createBlock, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-92698ed4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "lookup-section" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "title" }, "Please enter the MPRN and click Verify to help us locate the energy meter for the property", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_5 = {
  key: 0,
  class: "title"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("p", null, "Please enter the 11-digit MPRN in the format: 10XXXXXXXXX")
], -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times-circle" }, null, -1))
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "The provided MPRN and property address do not match!", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " Please contact Property Button helpdesk at +35319696091, or reach out to us at 'support@propertybutton.ie'. ", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times-circle" }, null, -1))
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "address-title" }, "Address", -1))
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { key: 1 }
const _hoisted_18 = { key: 2 }
const _hoisted_19 = { key: 3 }
const _hoisted_20 = { key: 4 }
const _hoisted_21 = { key: 5 }
const _hoisted_22 = { class: "property-energy-information" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ul", null, [
  /*#__PURE__*/_createElementVNode("li", null, "MPRN:"),
  /*#__PURE__*/_createElementVNode("li", null, "Status:"),
  /*#__PURE__*/_createElementVNode("li", null, "Meter:"),
  /*#__PURE__*/_createElementVNode("li", null, "Meter No:")
], -1))
const _hoisted_24 = { key: 0 }
const _hoisted_25 = {
  key: 0,
  class: "further-energy-info"
}
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  id: "meter-readings-only",
  class: "further-energy-info-title"
}, "Please enter Meter Readings", -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "asteriskVisible" }, "Meter Reading Date", -1))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Pay as you go Meter", -1))
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Please select 'YES' if the tenant's meter ", -1))
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "is configured as a 'Pay as you Go' meter.", -1))
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Giving us this information in advance will", -1))
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "reduce the amount of time your switch will", -1))
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "take to be approved by a supplier.", -1))
const _hoisted_40 = {
  key: 0,
  class: "housing-development-container"
}
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "New Development Property", -1))
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Select YES if the property is being switched", -1))
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "from a developers name for the first time.", -1))

import SelectOption from "@/components/ui/inputs/select-option.vue";
import MprnPropertyLookup from "@/components/ui/lookup/mprn-property-lookup.vue";
import scrollView from "@/components/ui/scroll-view.vue";
import { FieldSize } from "@/enums/system/FieldSize";
import { ElectricityMeterTypes } from "@/enums/utility-switching/ElectricityMeterTypes";
import { EnergyTypes } from "@/enums/utility-switching/EnergyTypes";
import { Address } from "@/types/generic/Address";
import { EnergyDetails } from "@/types/switches/EnergyDetails";
import { MprnLookupResponse } from "@/types/switches/MprnLookupResponse";
import { PropType, computed, onMounted, ref, watch } from "vue";
import FieldValidationFreeDateBox from "../ui/inputs/field-validation-free-date-box.vue";
import { tenantSwitchConfirmAddress } from "@/alerts/tenantSwitchConfirmAddress";
import FieldValidationFreeTextbox from "../ui/inputs/field-validation-free-textbox.vue";
import { GasMeterTypes } from "@/enums/utility-switching/GasMeterTypes";
import { SelectOptionReponses } from "@/enums/SelectOptionResponses";
import { TextboxValueChangeEvent } from "@/enums/ui/inputs/TextboxValueChangeEvent";


export default /*#__PURE__*/_defineComponent({
  __name: 'energy-details-page',
  props: {
  /**
   * The energy details associated with the property.
   * @type {EnergyDetails}
   * @required
   */
  energy: {
    type: Object as PropType<EnergyDetails>,
    required: true,
  },

  /**
   * The address object containing details about the location.
   * @type {Address}
   * @required
   */
  address: {
    type: Object as PropType<Address>,
    required: true,
  },

  /**
   * The validation group identifier for managing form validations.
   * @type {string}
   * @default ''
   */
  validationGroup: {
    type: String,
    default: "",
  },

  /**
   * Indicates whether the address should be validated.
   * @type {boolean}
   * @required
   */
  addressValidated: {
    type: Boolean,
    required: true,
  },

  /**
   * The numeric value indicating the energy type.
   * @type {number}
   * @default -1
   */
  energyType: {
    type: Number,
    required: true,
  },

  /**
   * The numeric value indicating the gas meter type.
   * @type {number}
   * @default -1
   */
  gasMeterType: {
    type: Number,
    default: -1,
  },

  /**
   * Indicates whether to show the housing development question.
   * @type {boolean}
   * @default false
   */
  showHousingDevelopmentQuestion: {
    type: Boolean,
    default: false,
  },

  /**
   * The numeric value indicating the selected option for housing development.
   * @type {number}
   * @default -1
   */
  housingDevelopmentSelectedOption: {
    type: Number,
    default: -1,
  },
},
  emits: [
  "update:energy",
  "update:addressValidated",
  "disableNextButton",
  "payAsYouGoSelected",
  "update:energyType",
  "updateNewHousingDevelopment",
],
  setup(__props, { emit }) {

const props = __props;



onMounted(() => {
  closeError.value = true;
});

const addressValid = computed({
  get: () => props.addressValidated,
  set: (value: Boolean) => emit("update:addressValidated", value),
});



const energyInformation = computed({
  get: () => props.energy,
  set: (value: EnergyDetails) => emit("update:energy", value),
});

const paygOptionSelected = (buttonSelected: number) => {
  energyInformation.value.payAsYouGo =
    buttonSelected === SelectOptionReponses.Yes;
  emit("payAsYouGoSelected");
};

const energyType = computed({
  get: () => props.energyType,
  set: (value: Number) => emit("update:energyType", value),
});

const energyTypeSelected = (buttonSelected: number) => {
  energyType.value = buttonSelected;

  switch (buttonSelected) {
    case EnergyTypes.DualFuel:
      energyInformation.value.energyType = "Dual Fuel";
      break;
    case EnergyTypes.ElectricityOnly:
      energyInformation.value.energyType = "Electricity Only";
      break;
    case EnergyTypes.GasOnly:
      energyInformation.value.energyType = "Gas Only";
      break;
  }
};

const currrentDate = ref(
  new Date(new Date(Date.now()).setHours(23, 59, 59, 59)),
);
const mprnAddressInformation = ref<MprnLookupResponse>();
const selectedMprn = ref("");
const searchSuccess = ref(false);
const invalidMprnEntered = ref(false);

const propertyFound = (
  addressInformation: MprnLookupResponse,
  mprn: string,
) => {
  addressValid.value = true;
  invalidMprnEntered.value = false;
  closeError.value = false;
  mprnAddressInformation.value = addressInformation;
  selectedMprn.value = mprn;
  searchSuccess.value = true;
  energyInformation.value.mprn = mprn;
  energyInformation.value.electricMeterType =
    addressInformation.electricMeterType;

  // If the address doen't match the address entered on the first page, a popup will appear so the
  // user can confirm the address
  if (!mprnAddressInformation.value.addressMatched) {
    tenantSwitchConfirmAddress(
      `${formattedMprnAddress.value}`,
      popupWidth.value,
    ).then((result: any) => {
      if (result.isConfirmed) {
        addressValid.value = true;
        emit("disableNextButton", false, mprnAddressInformation.value);
        emit("disableNextButton", false, mprnAddressInformation.value);
      } else {
        addressValid.value = false;
        emit("disableNextButton", true);
        emit("disableNextButton", true);
      }
    });
  } else {
    emit("disableNextButton", false, mprnAddressInformation.value);
    emit("disableNextButton", false, mprnAddressInformation.value);
  }
};

/** MPRN address without null/empty values, separated by commas */
const formattedMprnAddress = computed(() => {
  if (!mprnAddressInformation.value) {
    return "";
  }
  return [
    mprnAddressInformation.value.addressPropertyName,
    mprnAddressInformation.value.addressStreet,
    mprnAddressInformation.value.addressLocality,
    mprnAddressInformation.value.addressTown,
    mprnAddressInformation.value.addressRegion,
    mprnAddressInformation.value.addressPostcode,
  ]
    .filter((item) => !!item)
    .join(", ");
});

const closeError = ref(false);

const closeErrorMessage = () => {
  closeError.value = true;
};

const screeWidth = ref(screen.width);

const smallScreen = computed(() => screeWidth.value < 875);

const popupWidth = computed(() => (smallScreen.value ? "75vw" : "32.5vw"));

const showTwentyFourMeterRead = computed(() => {
  if (!mprnAddressInformation.value) {
    return false;
  }

  return (
    (mprnAddressInformation.value.electricMeterType ==
      ElectricityMeterTypes.Standard ||
      mprnAddressInformation.value.electricMeterType ==
        ElectricityMeterTypes.Smart ||
      mprnAddressInformation.value.electricMeterType ==
        ElectricityMeterTypes.StandardNightSaver) &&
    (energyType.value == EnergyTypes.ElectricityOnly ||
      energyType.value == EnergyTypes.DualFuel)
  );
});

const showNightMeterRead = computed(() => {
  if (!mprnAddressInformation.value) {
    return false;
  }

  return (
    (mprnAddressInformation.value.electricMeterType ==
      ElectricityMeterTypes.DayNight ||
      mprnAddressInformation.value.electricMeterType ==
        ElectricityMeterTypes.DayNightPeak) &&
    (energyType.value == EnergyTypes.ElectricityOnly ||
      energyType.value == EnergyTypes.DualFuel)
  );
});

const showDayMeterRead = computed(() => {
  if (!mprnAddressInformation.value) {
    return false;
  }

  return (
    (mprnAddressInformation.value.electricMeterType ==
      ElectricityMeterTypes.DayNight ||
      mprnAddressInformation.value.electricMeterType ==
        ElectricityMeterTypes.DayNightPeak) &&
    (energyType.value == EnergyTypes.ElectricityOnly ||
      energyType.value == EnergyTypes.DualFuel)
  );
});

const showPeakMeterRead = computed(() => {
  if (!mprnAddressInformation.value) {
    return false;
  }

  return (
    mprnAddressInformation.value.electricMeterType ==
      ElectricityMeterTypes.DayNightPeak &&
    (energyType.value == EnergyTypes.ElectricityOnly ||
      energyType.value == EnergyTypes.DualFuel)
  );
});

const showNightSaveMeter = computed(() => {
  if (!mprnAddressInformation.value) {
    return false;
  }

  return (
    mprnAddressInformation.value.electricMeterType ==
      ElectricityMeterTypes.StandardNightSaver &&
    (energyType.value == EnergyTypes.ElectricityOnly ||
      energyType.value == EnergyTypes.DualFuel)
  );
});

const showGasFields = computed(() => {
  return (
    energyType.value == EnergyTypes.GasOnly ||
    energyType.value == EnergyTypes.DualFuel
  );
});

const searchFailed = () => {
  searchSuccess.value = false;
  invalidMprnEntered.value = true;
  closeError.value = false;
};

// If a user changes their searched for MPRN number without searching for it another time, they cannot progress forwards until they research the MPRN number
const mprnUpdated = () => {
  if (selectedMprn.value) {
    emit("disableNextButton", true);
  }

  searchSuccess.value = false;
};

const meterType = computed(() => {
  if (!mprnAddressInformation.value) {
    return "";
  }

  switch (mprnAddressInformation.value.electricMeterType) {
    case ElectricityMeterTypes.StandardNightSaver:
      return "Gen 24hr Meter + Night Saver";
    case ElectricityMeterTypes.Standard:
      return "Gen 24Hr Meter";
    case ElectricityMeterTypes.Smart:
      return "Half Hourly Smart Meter";
    case ElectricityMeterTypes.DayNight:
      return "Day/Night Meter";
    case ElectricityMeterTypes.DayNightPeak:
      return "Day/Night/Peak Bi-Monthly Smart Meter";
    default:
      return "";
  }
});

const setPaygNo = computed(() => {
  switch (props.gasMeterType) {
    case GasMeterTypes.smart:
      return true;
    case GasMeterTypes.standard:
      return true;
    default:
      return false;
  }
});

const pAYGValue = computed(() => {
  return props.gasMeterType == GasMeterTypes.smart ||
    props.gasMeterType == GasMeterTypes.standard
    ? 2
    : props.gasMeterType;
});

const updateNewHousingDevelopmentOption = (buttonSelected: number) => {
  emit(
    "updateNewHousingDevelopment",
    buttonSelected === SelectOptionReponses.Yes,
  );
};

// When address changes, force users to revalidate the mprn number
watch(
  () => props.address,
  () => {
    addressValid.value = false;
    searchSuccess.value = false;
  },
  { deep: true },
);

// This ensures 'No' is selected by default when a user confirms an address is an Acquaint address.
const defaultHousingOption = computed(
  () => props.housingDevelopmentSelectedOption == SelectOptionReponses.No,
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(scrollView, null, {
    default: _withCtx(() => [
      _createElementVNode("section", {
        class: _normalizeClass(["energy-details", { smallScreen: smallScreen.value }])
      }, [
        _createElementVNode("div", _hoisted_1, [
          _hoisted_2,
          _hoisted_3,
          _createVNode(MprnPropertyLookup, {
            numericalField: true,
            address: props.address,
            label: "MPRN",
            mprn: __props.energy.mprn,
            onPropertyFound: propertyFound,
            validationGroup: props.validationGroup,
            invalidMessage: "Please enter the 11-digit MPRN in the format: 10XXXXXXXXX",
            onSearchFailed: searchFailed,
            onMprnUpdated: mprnUpdated
          }, null, 8, ["address", "mprn", "validationGroup"]),
          _hoisted_4,
          (searchSuccess.value && addressValid.value)
            ? (_openBlock(), _createElementBlock("span", _hoisted_5, "Property Details"))
            : _createCommentVNode("", true),
          _hoisted_6,
          (invalidMprnEntered.value && !closeError.value)
            ? (_openBlock(), _createElementBlock("div", {
                key: 1,
                class: _normalizeClass(["error-message invalid-message", { smallError: smallScreen.value }])
              }, [
                _hoisted_7,
                _createElementVNode("span", { onClick: closeErrorMessage }, _hoisted_9)
              ], 2))
            : _createCommentVNode("", true),
          (!addressValid.value && !closeError.value && searchSuccess.value)
            ? (_openBlock(), _createElementBlock("div", {
                key: 2,
                class: _normalizeClass(["error-message mprn-mismatch-error", { smallError: smallScreen.value }])
              }, [
                _createElementVNode("div", null, [
                  _hoisted_10,
                  _hoisted_11,
                  _createElementVNode("p", null, "Please reference the MPRN number: " + _toDisplayString(selectedMprn.value), 1)
                ]),
                _createElementVNode("span", { onClick: closeErrorMessage }, _hoisted_13)
              ], 2))
            : _createCommentVNode("", true),
          (searchSuccess.value && addressValid.value)
            ? (_openBlock(), _createElementBlock("div", {
                key: 3,
                class: _normalizeClass(["property-information", { smallScreen: smallScreen.value }])
              }, [
                _createElementVNode("div", null, [
                  _hoisted_14,
                  (mprnAddressInformation.value)
                    ? (_openBlock(), _createElementBlock("ul", _hoisted_15, [
                        (mprnAddressInformation.value.addressPropertyName)
                          ? (_openBlock(), _createElementBlock("li", _hoisted_16, _toDisplayString(mprnAddressInformation.value.addressPropertyName), 1))
                          : _createCommentVNode("", true),
                        (mprnAddressInformation.value.addressStreet)
                          ? (_openBlock(), _createElementBlock("li", _hoisted_17, _toDisplayString(mprnAddressInformation.value.addressStreet), 1))
                          : _createCommentVNode("", true),
                        (mprnAddressInformation.value.addressLocality)
                          ? (_openBlock(), _createElementBlock("li", _hoisted_18, _toDisplayString(mprnAddressInformation.value.addressLocality), 1))
                          : _createCommentVNode("", true),
                        (mprnAddressInformation.value.addressTown)
                          ? (_openBlock(), _createElementBlock("li", _hoisted_19, _toDisplayString(mprnAddressInformation.value.addressTown), 1))
                          : _createCommentVNode("", true),
                        (mprnAddressInformation.value.addressRegion)
                          ? (_openBlock(), _createElementBlock("li", _hoisted_20, _toDisplayString(mprnAddressInformation.value.addressRegion), 1))
                          : _createCommentVNode("", true),
                        (mprnAddressInformation.value.addressPostcode)
                          ? (_openBlock(), _createElementBlock("li", _hoisted_21, _toDisplayString(mprnAddressInformation.value.addressPostcode), 1))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_22, [
                  _hoisted_23,
                  (mprnAddressInformation.value)
                    ? (_openBlock(), _createElementBlock("ul", _hoisted_24, [
                        _createElementVNode("li", null, _toDisplayString(selectedMprn.value), 1),
                        _createElementVNode("li", null, _toDisplayString(mprnAddressInformation.value.electricEnergised
                    ? "Energised"
                    : "Non-Energised"), 1),
                        _createElementVNode("li", null, _toDisplayString(meterType.value), 1),
                        _createElementVNode("li", null, _toDisplayString(mprnAddressInformation.value.electricMeterSerialNumber), 1)
                      ]))
                    : _createCommentVNode("", true)
                ])
              ], 2))
            : _createCommentVNode("", true)
        ]),
        (searchSuccess.value && addressValid.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
              _createVNode(SelectOption, {
                title: "Please select the type of Energy at this Property",
                boldTitle: true,
                selectBoxOneText: "Dual Fuel",
                selectBoxTwoText: "Electricity Only",
                selectBoxThreeText: "Gas Only",
                width: "105px",
                onButtonSelected: energyTypeSelected,
                value: energyType.value
              }, null, 8, ["value"]),
              _hoisted_26,
              _hoisted_27,
              _createElementVNode("div", {
                class: _normalizeClass(["gas-readings", { smallScreen: smallScreen.value }])
              }, [
                _createElementVNode("div", null, [
                  (showTwentyFourMeterRead.value)
                    ? (_openBlock(), _createBlock(FieldValidationFreeTextbox, {
                        key: 0,
                        placeholder: "5 digits required...",
                        modelValue: energyInformation.value.twentyfourHMeterRead,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((energyInformation.value.twentyfourHMeterRead) = $event)),
                        label: "24H Meter Read",
                        maxLength: "5",
                        validationGroup: props.validationGroup,
                        "required-input": true,
                        width: _unref(FieldSize).Small,
                        numericalField: true,
                        valueChangeEvent: _unref(TextboxValueChangeEvent).KeyUp,
                        invalidNumericalMessage: "Please enter the 5-digit 24H meter read in the format: 12345",
                        minLength: "5",
                        displayLeadingZeros: true
                      }, null, 8, ["modelValue", "validationGroup", "width", "valueChangeEvent"]))
                    : _createCommentVNode("", true),
                  (showDayMeterRead.value)
                    ? (_openBlock(), _createBlock(FieldValidationFreeTextbox, {
                        key: 1,
                        placeholder: "5 digits required...",
                        modelValue: energyInformation.value.dayMeterMeterRead,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((energyInformation.value.dayMeterMeterRead) = $event)),
                        label: "Day Meter Read",
                        maxLength: "5",
                        validationGroup: props.validationGroup,
                        "required-input": true,
                        width: _unref(FieldSize).Small,
                        numericalField: true,
                        valueChangeEvent: _unref(TextboxValueChangeEvent).KeyUp,
                        invalidNumericalMessage: "Please enter the 5-digit Day meter read in the format: 12345",
                        minLength: "5",
                        displayLeadingZeros: true
                      }, null, 8, ["modelValue", "validationGroup", "width", "valueChangeEvent"]))
                    : _createCommentVNode("", true),
                  (showPeakMeterRead.value)
                    ? (_openBlock(), _createBlock(FieldValidationFreeTextbox, {
                        key: 2,
                        placeholder: "5 digits required...",
                        modelValue: energyInformation.value.peakMeterRead,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((energyInformation.value.peakMeterRead) = $event)),
                        label: "Peak Meter Read",
                        maxLength: "5",
                        validationGroup: props.validationGroup,
                        "required-input": true,
                        width: _unref(FieldSize).Small,
                        numericalField: true,
                        valueChangeEvent: _unref(TextboxValueChangeEvent).KeyUp,
                        invalidNumericalMessage: "Please enter the 5-digit Peak meter read in the format: 12345",
                        minLength: "5",
                        displayLeadingZeros: true
                      }, null, 8, ["modelValue", "validationGroup", "width", "valueChangeEvent"]))
                    : _createCommentVNode("", true),
                  (showNightMeterRead.value)
                    ? (_openBlock(), _createBlock(FieldValidationFreeTextbox, {
                        key: 3,
                        placeholder: "5 digits required...",
                        modelValue: energyInformation.value.nightMeterRead,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((energyInformation.value.nightMeterRead) = $event)),
                        label: "Night Meter Read",
                        maxLength: "5",
                        validationGroup: props.validationGroup,
                        "required-input": true,
                        width: _unref(FieldSize).Small,
                        numericalField: true,
                        valueChangeEvent: _unref(TextboxValueChangeEvent).KeyUp,
                        invalidNumericalMessage: "Please enter the 5-digit Night meter read in the format: 12345",
                        minLength: "5",
                        displayLeadingZeros: true
                      }, null, 8, ["modelValue", "validationGroup", "width", "valueChangeEvent"]))
                    : _createCommentVNode("", true),
                  (showNightSaveMeter.value)
                    ? (_openBlock(), _createBlock(FieldValidationFreeTextbox, {
                        key: 4,
                        placeholder: "5 digits required...",
                        modelValue: energyInformation.value.nightSaverMeterRead,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((energyInformation.value.nightSaverMeterRead) = $event)),
                        label: "Night Saver Meter Read",
                        maxLength: "5",
                        validationGroup: props.validationGroup,
                        "required-input": true,
                        width: _unref(FieldSize).Small,
                        numericalField: true,
                        valueChangeEvent: _unref(TextboxValueChangeEvent).KeyUp,
                        invalidNumericalMessage: "Please enter the 5-digit Night Saver meter read in the format: 12345",
                        minLength: "5",
                        displayLeadingZeros: true
                      }, null, 8, ["modelValue", "validationGroup", "width", "valueChangeEvent"]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", null, [
                  (showGasFields.value)
                    ? (_openBlock(), _createBlock(FieldValidationFreeTextbox, {
                        key: 0,
                        placeholder: "7 digits required...",
                        modelValue: energyInformation.value.gasGPRNNum,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((energyInformation.value.gasGPRNNum) = $event)),
                        label: "Gas GPRN Number",
                        maxLength: "7",
                        validationGroup: props.validationGroup,
                        "required-input": true,
                        width: _unref(FieldSize).Small,
                        numericalField: true,
                        valueChangeEvent: _unref(TextboxValueChangeEvent).KeyUp,
                        invalidNumericalMessage: "Please enter the 7-digit GPRN number in the format 1234567",
                        minLength: "7"
                      }, null, 8, ["modelValue", "validationGroup", "width", "valueChangeEvent"]))
                    : _createCommentVNode("", true),
                  (showGasFields.value)
                    ? (_openBlock(), _createBlock(FieldValidationFreeTextbox, {
                        key: 1,
                        placeholder: "5 digits required...",
                        modelValue: energyInformation.value.gasMeterRead,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((energyInformation.value.gasMeterRead) = $event)),
                        label: "Gas Meter Read",
                        maxLength: "5",
                        validationGroup: props.validationGroup,
                        "required-input": true,
                        width: _unref(FieldSize).Small,
                        numericalField: true,
                        valueChangeEvent: _unref(TextboxValueChangeEvent).KeyUp,
                        invalidNumericalMessage: "Please enter the 5-digit Gas Meter Read in the format 12345",
                        minLength: "5",
                        displayLeadingZeros: true
                      }, null, 8, ["modelValue", "validationGroup", "width", "valueChangeEvent"]))
                    : _createCommentVNode("", true)
                ])
              ], 2),
              _createElementVNode("div", {
                class: _normalizeClass(["date-payg-container", { smallScreen: smallScreen.value }])
              }, [
                _createElementVNode("div", null, [
                  _hoisted_28,
                  _createVNode(FieldValidationFreeDateBox, {
                    modelValue: energyInformation.value.readingDate,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((energyInformation.value.readingDate) = $event)),
                    width: _unref(FieldSize).Small,
                    validationGroup: props.validationGroup,
                    required: true,
                    maxDate: currrentDate.value
                  }, null, 8, ["modelValue", "width", "validationGroup", "maxDate"])
                ]),
                (energyType.value != _unref(EnergyTypes).ElectricityOnly)
                  ? (_openBlock(), _createBlock(SelectOption, {
                      key: 0,
                      title: "Pay as you go Gas Meter?",
                      selectBoxTwoText: "No",
                      selectBoxOneText: "Yes",
                      width: "105px",
                      onButtonSelected: paygOptionSelected,
                      useToolTip: true,
                      toolTipId: "meter",
                      toolTipTarget: "#meter",
                      "selected-by-default": setPaygNo.value,
                      showAskterisk: true,
                      boldTitle: true,
                      value: pAYGValue.value,
                      titleSpacing: "flex-start"
                    }, {
                      "tooltip-content": _withCtx(() => [
                        _hoisted_29,
                        _hoisted_30,
                        _hoisted_31,
                        _hoisted_32,
                        _hoisted_33,
                        _hoisted_34,
                        _hoisted_35,
                        _hoisted_36,
                        _hoisted_37,
                        _hoisted_38,
                        _hoisted_39
                      ]),
                      _: 1
                    }, 8, ["selected-by-default", "value"]))
                  : _createCommentVNode("", true)
              ], 2),
              (props.showHousingDevelopmentQuestion)
                ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                    _createVNode(SelectOption, {
                      title: "Is this property part of a new housing development?",
                      selectBoxTwoText: "No",
                      selectBoxOneText: "Yes",
                      width: "105px",
                      onButtonSelected: updateNewHousingDevelopmentOption,
                      useToolTip: true,
                      toolTipId: "housingDevelopment",
                      toolTipTarget: "#housingDevelopment",
                      showAskterisk: true,
                      boldTitle: true,
                      titleSpacing: "flex-start",
                      selectedByDefault: defaultHousingOption.value,
                      value: props.housingDevelopmentSelectedOption
                    }, {
                      "tooltip-content": _withCtx(() => [
                        _hoisted_41,
                        _hoisted_42,
                        _hoisted_43,
                        _hoisted_44,
                        _hoisted_45
                      ]),
                      _: 1
                    }, 8, ["selectedByDefault", "value"])
                  ]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ], 2)
    ]),
    _: 1
  }))
}
}

})